import { EmployeeInactiveHeader } from "./components/EmployeeInactiveHeader";
import { EmployeeInactiveContent } from "./components/EmployeeInactiveContent";
import { setCurrentPage, setItemsPerPage } from "./EmployeeInactiveSlice";
import React, { JSX } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useGetCertificatesQuery } from "../../common/api/certificate";
import { useEstablishmentId } from "../../common/utils/useEstablishmentId";
import { SecondaryPagination } from "@hatch-digital-nl/abs-storybook/legacy";

export const EmployeeInactivePage = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { currentPage, itemsPerPage, itemsPerPageSelect } = useAppSelector(
        (state) => state.employeeInactive,
    );
    const { data: certificatesData } = useGetCertificatesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            status: "active",
            establishment_id: useEstablishmentId(),
        },
    });

    return (
        <div className={"p-employee-inactive"}>
            <EmployeeInactiveHeader />
            <div className={"p-employee-inactive__content"}>
                <EmployeeInactiveContent />
                <div className={"p-employee-inactive__content__pagination"}>
                    {certificatesData && (
                        <SecondaryPagination
                            itemsPerPage={itemsPerPage}
                            totalItems={certificatesData?.meta?.total || 0}
                            currentPage={currentPage}
                            onPaginationChange={(page: number) =>
                                dispatch(setCurrentPage(page))
                            }
                            totalItemsOnCurrentPage={
                                certificatesData?.data.length || 0
                            }
                            onItemsPerPageChange={(
                                event: React.ChangeEvent<HTMLSelectElement>,
                            ) =>
                                dispatch(
                                    setItemsPerPage(Number(event.target.value)),
                                )
                            }
                            itemsPerPageSelect={itemsPerPageSelect}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
